import styled, { css } from 'styled-components';
import CONTENTO_PRESENTATION_TYPES from '../../../domain/ContentoPresentationTypes';
import { device, deviceGte } from '../../breakpoints';
import { regularWhite } from '../../design-tokens';
import { playFontSize } from '../../typography/helpers';
import { CARD_TYPE } from '../ContentItemCarousel';

const getPlacement = (direction) => {
    if (direction === 'RIGHT') {
        return css`
            right: 10px;

            @media ${device.GteXLarge} {
                right: -47px;
            }
        `;
    }

    return css`
        left: 10px;
        @media ${device.GteXLarge} {
            left: -47px;
        }
    `;
};

const getPosition = (presentation, cardType) => {
    if (cardType === CARD_TYPE.SHOWCASE) {
        return css`
            top: 25px;

            @media ${device.GteMedium} {
                top: 35px;
            }

            @media ${deviceGte(867)} {
                top: 45px;
            }

            @media ${device.GteLarge} {
                top: 55px;
            }

            @media ${device.GteXLarge} {
                top: 100px;
            }

            @media ${deviceGte(1400)} {
                top: 138px;
            }
        `;
    }

    if (presentation === CONTENTO_PRESENTATION_TYPES.PORTRAIT) {
        return css`
            top: 100px;

            @media ${device.GteMedium} {
                top: 115px;
            }

            @media ${deviceGte(867)} {
                top: 115px;
            }

            @media ${device.GteLarge} {
                top: 182px;
            }

            @media ${device.GteXLarge} {
                top: 150px;
            }

            @media ${deviceGte(1400)} {
                top: 182px;
            }

            @media ${device.FullScreen} {
                top: 195px;
            }
        `;
    }

    return css`
        top: 25px;

        @media ${device.GteMedium} {
            top: 35px;
        }

        @media ${deviceGte(867)} {
            top: 45px;
        }

        @media ${device.GteLarge} {
            top: 55px;
        }

        @media ${device.GteXLarge} {
            top: 60px;
        }

        @media ${device.FullScreen} {
            top: 65px;
        }
    `;
};

export const StyledCustomArrow = styled.button`
    font-size: 20px;
    position: absolute;
    ${(props) => getPlacement(props.direction)}
    outline: 0;
    border-radius: 25px;
    background: rgba(0, 0, 0, 0.7);
    z-index: 100;
    border: 0;
    min-width: 45px;
    min-height: 45px;
    cursor: pointer;
    transition: all 0.5s;
    transition: opacity 100ms ease-in-out;
    opacity: 1;

    ${(props) => getPosition(props.presentation, props.cardType)}

    ${(props) =>
        props.disable &&
        css`
            display: none;
        `}

    @media ${device.GteXLarge} {
        font-size: 36px;
        background: none;
        border: none;

        &:hover {
            transform: none;
        }
    }

    &:hover {
        transform: scale(1.1);
    }

    &:disabled {
        opacity: 0;
        pointer-events: none;
    }

    .touchevents & {
        display: none;
    }

    &:disabled:hover {
        opacity: 0.2;
        display: block;
        pointer-events: all;
    }
`;

export const ArrowIcon = styled.span`
    ${playFontSize(2.4)};
    color: ${regularWhite};
    opacity: 80%;

    @media ${device.GteXLarge} {
        ${playFontSize(4)};

        &:hover {
            opacity: 100%;
            transform: scale(1.1);
            transition: all 0.2s ease-in-out;
        }
    }
`;
